import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, SerializationContext, SerializedData, DataModelBuilder } from '../../dto/data-model.js';
import { isSameList, isSameData } from '../../dto/data-model-utils.js';
import { DiscoverMetadata } from '../discover-content.js';
import { NewsPost } from './news-post.js';

export class NewsContent extends DataModel {
  static readonly TYPE_ID: string = 'f20e8e02bd7e4f6b9d03f76ea851da91';

  constructor(
    public readonly uniqueId: string,
    public readonly webRoute: string,
    public readonly posts: NewsPost[],
  ) {
    super();
  }

  static fromData(args: {
    metadata: DiscoverMetadata,
    posts: NewsPost[],
  }): NewsContent {
    return new NewsContent( args.metadata.uniqueId, args.metadata.webRoute, args.posts );
  }

  get $typeId(): string {
    return NewsContent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): NewsContent {
    return new NewsContent(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'webRoute'),
        MapUtils.getList<NewsPost>(map, 'posts', (value) => {
          return context.fromData<NewsPost>(value as SerializedData);
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'webRoute': this.webRoute,
      'posts': this.posts.map((e) => context.toData(e)),
    };
  }

  clone(): this {
    return new NewsContent(
        this.uniqueId,
        this.webRoute,
        this.posts.map((e) => e.clone()),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.webRoute === this.webRoute &&
        isSameList(other.posts, this.posts, isSameData);
  }
}

export class NewsContentBuilder extends DataModelBuilder<NewsContent> {
  build(context: SerializationContext, map: SerializedData): NewsContent {
    return NewsContent.fromMap(context, map);
  }
}
